import React from "react";
import { getFormmatedDate } from "../../utils/helper";
import "./styles/PreviewPatientTable.css";

const PreviewPatientTable = ({
  patientName,
  patientDOB,
  patientSex,
  patientID,
  orderBy,
  reportRecipient,
  contactInfo,
  amendedNotes,
}: any) => {

  return (
    <div className="patient-table patient-table-preview">
      {/* Patient Info */}
      <div className="box patient-info-box">
        <div className="box-header">
          <span>Patient information</span>
          <div className="bottom-line"></div>
        </div>
        <div className="box-content">
          <div className="field-group-1">
            <div className="field  name-field">
              <label>Name:</label>
              <span className="field-value">{patientName}</span>
            </div>
            <div className="field sex-field">
              <label>Sex:</label>
              <span className="field-value">{patientSex}</span>
            </div>
          </div>
          
          <div className="field-group-2">
            <div className="field dob-field">
              <label>Date of birth:</label>
              <span className="field-value">{patientDOB ? getFormmatedDate(patientDOB) : "MM/DD/YYYY"}</span>
            </div>
            <div className="field">
              <label>Patient ID:</label>
              <span className="field-value">{patientID}</span>
            </div>
          </div>
        </div>
        {/* Note */}
        <div className="box note-box">
          <div className="box-header">
            <span>Note</span>
            <div className="bottom-line"></div>
          </div>
          <div className="box-content">
            {amendedNotes}
          </div>
        </div>
      </div>



      <div className="box-right">
        {/* Report Recipient */}
        <div className="box report-box">
          <div className="box-header">
            <span>Report recipient</span>
            <div className="bottom-line"></div>
          </div>
          {/*  */}
          <div className="box-content">
            <div className="field">
              <label>Ordered by: </label>
              <span className="field-value">{orderBy}</span>
            </div>
            <div className="report-and-contact">
              <div className="report-value" dangerouslySetInnerHTML={{ __html: reportRecipient }}></div>
              <div className="contact-value" dangerouslySetInnerHTML={{ __html: contactInfo }}></div>
            </div>
          </div>
        </div>
      </div>
      
    </div>

  );
};

export default PreviewPatientTable;
